<template>
  <div class="mx-auto mb-4" v-if="rows" :class="{ dark }">
    <v-simple-table dense class="table">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="text-center pa-2">Numero squadre max</th>
            <th class="text-center pa-2">Prezzo</th>
            <th class="text-left text--text text--lighten-2 pa-2">
              Equivalente circa di
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="row in rows"
            :key="row.legaDa"
            :class="{ selezionato: row.selezionato }"
          >
            <td class="text-center pa-2" width="150">{{ row.legaDa }}</td>
            <td class="text-center pa-2" width="100">
              <b>{{ row.prezzo }}</b>
            </td>
            <td class="text-left text--text text--lighten-2 pa-2">
              {{ row.comment }}
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <!-- <v-data-table
            dense
            :headers="headers"
            :items="rows"
            hide-default-footer
            disable-sort
            class="prezzi mx-auto mb-4"
          ></v-data-table> -->
  </div>
</template>



<script>
import mixins from "../../js/mixins";

export default {
  name: "tabella-prezzi",
  mixins: [mixins],
  components: {},
  data() {
    return {
      rows: [],
    };
  },
  props: {
    maxSquadre: null,
    dark: {
      type: Boolean,
    },
  },
  mounted() {
    this.rows = this.convert();
  },
  destroyed() {},
  methods: {
    convert() {
      const rowsPrezzi = this.getRowsPrezzi();
      let output = [];
      let prezzo = 0;
      let i = -1;
      rowsPrezzi.forEach((element) => {
        if (prezzo == element.prezzo) {
          output[i].legaDa += ", " + element.legaDa;
        } else {
          i++;
          output[i] = element;
          prezzo = element.prezzo;
        }
        // se è stato passata una prop e nn è stato ancora selezionato, controlla se è selezionabile
        if (!output[i].selezionato && this.maxSquadre) {
          output[i].selezionato =
            element.legaDa == this.maxSquadre ? true : false;
        }
      });
      return output;
    },
  },
  computed: {},
  // headers: [
  //   { text: "Max partecipanti", align: "end", value: "legaDa" },
  //   { text: "Prezzo", align: "center", value: "prezzo" },
  //   { text: "", align: "start", value: "comment" },
  // ],
  // rows: []
  // rows: [
  //   {
  //     legaDa: "2",
  //     prezzo: "	1.09 € *",
  //     comment: "Equivalente di soli 0.55 €/persona **",
  //   },
  //   {
  //     legaDa: "4",
  //     prezzo: "2.29 € *	",
  //     comment: "Equivalente di soli 0.57 €/persona **",
  //   },
  //   {
  //     legaDa: "6",
  //     prezzo: "3.49 € *",
  //     comment: "Equivalente di soli 0.58 €/persona **",
  //   },
  //   {
  //     legaDa: "8",
  //     prezzo: "4.49 € *",
  //     comment: "Equivalente di soli 0.56 €/persona **",
  //   },
  //   {
  //     legaDa: "10",
  //     prezzo: "5.49 € *",
  //     comment: "Equivalente di soli 0.55 €/persona **",
  //   },
  //   {
  //     legaDa: "da 12 a 20",
  //     prezzo: "7.99 € *",
  //     comment: "Da 0.58€ fino a soli 0.35 €/persona **",
  //   },
  // ],
};
</script>
<style lang="scss" scoped>
@import "../../main.scss";
tr:hover {
  background: inherit !important;
}
tr.selezionato {
  background: #fff8ec !important;
}
.dark .v-data-table.table {
  background-color: var(--v-navy-darken2) !important;
  td,
  th {
    color: white !important;
  }
}
</style>
